module.exports = __webpack_public_path__ + "digital-new-logo.png?b9631f3f55abe544568e2c12fb6e5af3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/digital-new-logo.png
// module id = 109
// module chunks = 0